<div *ngIf="isSpinning == true" class="spinner">
  <nz-spin [nzSpinning]="isSpinning" nzSimple [nzSize]="'large'"></nz-spin>
</div>
<section *ngIf="isSpinning == false" class="bgblue-sm">
  <!-- top  -->
  <section id="s-checkin" *ngIf="isHeader">
    <div class="w-100 text-center py-3">
      <div class="container py-2">
        <div class="row">
          <div class="col-12 text-center">
            <img alt="Brand" src="assets/img/logo.svg" class="img img-fluid" (click)="backToSelectService()" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- end top -->
  <div *ngIf="isAuthenticated" class="container mr-t-15">
    <button nz-button nzType="primary" nzSize="medium" nzShape="round" class="col-sm-4 col-sm-offset-8"
      (click)="logout()" *ngIf="!isLoadingButtonInModal">Đăng xuất</button>
    <button nz-button nzType="primary" nzSize="medium" nzShape="round" class="col-sm-4 col-sm-offset-8"
      *ngIf="isLoadingButtonInModal">Đang xử lý</button>
  </div>

  <section>
    <div *ngIf="isSelected == 0" class="pb-4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mb-4 mt-4">
            <div class="form-group row">
              <div class="col-md-12">
                <nz-skeleton *ngIf="isZaloChannel" [nzLoading]="!lstgroup" nzActive="true"></nz-skeleton>
                <input *ngIf="isHeader" [(ngModel)]="phone" type="text" class="input-field form-control" id="phone"
                  name="phone" required="true" required pattern="(84|0[1-9])+([0-9]{8})\b" minlength="10" maxlength="10"
                  placeholder="Vui lòng nhập số điện thoại" />
                <span class="invalid-phone" *ngIf="!isValid">{{msgError}}</span>
                <div *ngIf="!isHeader">
                  <div class="text-Welcome text-center pt-3">
                    Kính chào Quý khách<br>
                    <span>{{ customerName | uppercase}}</span>
                  </div>
                  <div *ngIf="customerName && customerName == phone">Kính chào Quý khách</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="lstgroup">
          <div class="col-lg-12 mb-4">
            <div class="text-please text-center">
              Vui lòng chọn dịch vụ để lấy số thứ tự giao dịch
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div *ngIf="splitTypeCus" class="boxService mt-3">
              <!--boxtab -->
              <div class="boxtab">
                <div class="row">
                  <div class="col-12 col-sm-12 col-lg-12">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item ml-2">
                        <a class="nav-link active" id="invidial-tab" data-toggle="tab" href="#invidial" role="tab"
                          aria-controls="invidial" aria-selected="true"><span class="tab-iconCN"></span> CÁ NHÂN</a>
                      </li>
                      <li class="nav-item ml-2 mr-2">
                        <a class="nav-link" id="corp-tab" data-toggle="tab" href="#corp" role="tab" aria-controls="corp"
                          aria-selected="false"><span class="tab-iconDN"></span> DOANH NGHIỆP</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!--end boxtab -->

              <div class="row">
                <div class="col-md-12">
                  <div class="tab-content">
                    <div class="tab-pane fade active show" id="invidial" role="tabpanel" aria-labelledby="invidial-tab">
                      <div class="row">
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4" *ngFor="let grp of lstgroup"
                          (click)="selectedService(1, grp.id)">
                          <div *ngIf="grp.groupName == 'CN'" class="service_item_container">
                            <div class="single-item">
                              <div class="icon">
                                <img src="assets{{ grp.iconPath }}" alt="icon" class="iconHeight img-fluid" />
                                <i class="lni lni-grid-alt"></i>
                              </div>
                              <h4 class="title">{{ grp.name }}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="corp" role="tabpanel" aria-labelledby="corp-tab">
                      <div class="row">
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4" *ngFor="let grp of lstgroup"
                          (click)="selectedService(1, grp.id)">
                          <div *ngIf="grp.groupName == 'DN'" class="service_item_container">
                            <div class="single-item">
                              <div class="icon">
                                <img src="assets{{ grp.iconPath }}" alt="icon" class="iconHeight img-fluid" />
                                <i class="lni lni-grid-alt"></i>
                              </div>
                              <h4 class="title">{{ grp.name }}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="!splitTypeCus" class="boxService">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-4" *ngFor="let grp of lstgroup"
                  (click)="selectedService(1, grp.id)">
                  <div class="service_item_container">
                    <div class="single-item">
                      <div class="icon">
                        <img src="assets{{ grp.iconPath }}" alt="icon" class="iconHeight img-fluid" />
                        <i class="lni lni-grid-alt"></i>
                      </div>
                      <h4 class="title">{{ grp.name }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isSelected == 1" class="bgmain content pb-4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mb-4 mt-4">
            <div class="row-full">
              <label class="cell-left40 control-label text-left">CN/PGD</label>
              <div class="cell-right60 control-fill text-right">
                {{ branchName }}
              </div>
            </div>
            <div class="row-full">
              <label class="cell-left40 control-label text-left">
                {{ customerName == phone ? "Số ĐT Khách hàng" : "Khách hàng" }}</label>
              <div class="cell-right60 control-fill text-right">
                {{ customerName }}
              </div>
            </div>
            <div class="row-full">
              <label class="cell-left40 control-label text-left">Dịch vụ</label>
              <div class="cell-right60 control-fill text-right">
                {{ productName }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 mb-4">
            <div class="text-result text-center">
              <img src="assets/img/svg-check.svg" alt="icon" class="h-64px img-fluid" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 mb-4">
            <div class="text-count text-center" *ngIf="!counter">
              Số thứ tự của Quý khách
            </div>
            <div class="text-count text-center" *ngIf="counter">
              Mời quý khách có số thứ tự
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-sm-offset-4">
            <!-- form -->
            <div class="container-number text-center">
              <div class="count-number">{{ queuestt }}</div>
            </div>
            <!-- end form -->
          </div>
        </div>

        <div class="row" [hidden]="statusQueue != 2">
          <div class="col-lg-12 mb-4">
            <div class="text-highlight text-center pt-3">
              Vui lòng đến quầy số
              <span class="text-counter">
                <img src="assets/img/hoavan.svg" alt="icon" class="h-64px" /><span>{{ counter }}</span></span>
              để được phục vụ
            </div>
          </div>
        </div>

        <div class="row" *ngIf="statusQueue != 2 && statusQueue != 5">
          <div class="col-lg-12 mb-4">
            <div class="text-highlight text-center pt-3">
              Quý khách vui lòng kiểm tra thông báo từ
              <span>{{ customerName != phone && isEwallet ? "SACOMBANK PAY" : "Zalo" }}</span> (*) để vào quầy giao dịch
            </div>
          </div>
        </div>

        <div class="row" *ngIf="statusQueue == 5">
          <div class="col-lg-12 mb-4">
            <div class="text-highlight text-center pt-3">
              Quý khách đã bị lỡ lượt giao dịch vui lòng liên hệ Nhân viên để được hỗ trợ
            </div>
          </div>
        </div>

        <div class="row" *ngIf="statusQueue != 2 && statusQueue != 5">
          <div class="col-lg-12 mb-4">
            <div class="text-note text-center">
              (*) Bật thông báo ứng dụng trên điện thoại
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isSelected == 2" class="container content pb-4">
      <div class="content mb-3">
        <div class="p-3 text-sacom text-medium">
          <div *ngFor="let p of lstProduct" class="p-3 service mb-3" (click)="selectForm(p.formCode)">
            {{ p.name }}
          </div>
        </div>
      </div>
    </div>
  </section>
</section>

<nz-modal [(nzVisible)]="isVisibleLoginModal" nzTitle="Đăng nhập" (nzOnCancel)="cancelLoginModal()"
  [nzContent]="modalContent" [nzFooter]="modalFooter">

  <ng-template #modalContent>
    <form nz-form [formGroup]="authenticateForm">
      <div class="row">
        <div class="mt-6 col-xs-12 col-sm-6">
          <nz-form-label nzRequired nzFor="txtUsername">Tên đăng nhập</nz-form-label>
          <input nz-input type="text" #txtUsername placeHolder="Vui lòng nhập tên đăng nhập"
            formControlName="username" />
        </div>
        <div class="mt-6 col-xs-12 col-sm-6">
          <nz-form-label nzRequired nzFor="txtPassword">Mật khẩu</nz-form-label>
          <input nz-input type="password" #txtPassword placeHolder="Vui lòng nhập mật khẩu"
            formControlName="password" />
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" nzSize="medium" nzShape="round" (click)="cancelLoginModal()"
      *ngIf="!isLoadingButtonInModal">Trở về</button>
    <button nz-button nzType="primary" nzSize="medium" nzShape="round" class="btn-sacom-o" (click)="submitLoginModal()"
      *ngIf="!isLoadingButtonInModal">Đăng nhập</button>
    <button nz-button nzType="primary" nzSize="medium" nzShape="round" class="btn-sacom-o btnDisabled"
      *ngIf="isLoadingButtonInModal">Đang xử lý</button>
  </ng-template>

</nz-modal>

<nz-modal [(nzVisible)]="isVisibleWarningModal" nzTitle="Cảnh báo" (nzOnCancel)="cancelWarningModal()"
  [nzContent]="modalWarningContent" [nzFooter]="modalWarningFooter">

  <ng-template #modalWarningContent>
    <p>Phiên đăng nhập của bạn sắp hết, bạn có muốn tiếp tục đăng nhập không?</p>
  </ng-template>

  <ng-template #modalWarningFooter>
    <button nz-button nzType="default" nzSize="medium" nzShape="round" (click)="cancelWarningModal()"
      *ngIf="!isLoadingButtonInModal">Bỏ qua</button>
    <button nz-button nzType="primary" nzSize="medium" nzShape="round" (click)="confirmExtendSessionModal()"
      *ngIf="!isLoadingButtonInModal">Tiếp tục</button>
  </ng-template>

</nz-modal>